import { QuoteStoryblok } from '../types/generated-storyblok';

interface ContentBlockQuoteProps {
  blok: QuoteStoryblok;
}

export const ContentBlockQuote = ({ blok }: ContentBlockQuoteProps) => {
  if (!blok?.text?.trim()) {
    return null;
  }

  return (
    <div className="aa-prose">
      <blockquote className="my-0 flex flex-col space-y-3">
        <p>{blok.text}</p>
        {blok.author && <span className="text-neutral-4">{blok.author}</span>}
      </blockquote>
    </div>
  );
};
